import React, { useEffect, useState } from "react";

import { Input, Label, UncontrolledTooltip } from "reactstrap";

export default function RadioDisplay({ attributes, rowId, colId, setValue }) {
  const [selected, setSelected] = useState(attributes.value || "");

  const setLabel = ({ value, id }) => {
    const html = value;
    const div = document.getElementsByClassName(
      `check-label-${rowId}-${colId}-${id}`,
    );

    for (const element of div) {
      element.innerHTML = html;
    }

    const askField = document.getElementsByClassName(
      `main-question-options-${rowId}-${colId}`,
    );

    for (const element of askField) {
      element.innerHTML = attributes.ask + (attributes.required ? '*' : '');
    }
  };

  useEffect(() => {
    setValue((oldValue) => {
      const newValue = [...oldValue];
      newValue[rowId].cols[colId].attributes.value = selected;
      if (!selected && attributes.required) {
        newValue[rowId].cols[colId].attributes.errorMessage =
          "Selecione pelo menos uma opção.";
      } else {
        newValue[rowId].cols[colId].attributes.errorMessage = "";
      }

      return newValue;
    });
  }, [selected, setValue, rowId, colId]);

  return (
    <div id="therm-input-component">
      <div className="custom-input-container">
        <div className="displayed-config-container">
          <div className="displayed-label">
            {/* FIX_SSR_LABEL — children literal com "*" quando required. */}
            <span className={`main-question-options-${rowId}-${colId}`}>
              {attributes.ask}
              {attributes.required ? "*" : ""}
            </span>
          </div>
        </div>
        {attributes.boxes.map((box, index) => (
          <div key={index} style={{ display: "flex" }}>
            <Input
              className="input-mg-rgt"
              name="displayed-radio"
              type="radio"
              id={`edit-input-radio-show-${index}`}
              checked={selected === box.label}
              onChange={() => setSelected(box.label)}
            />
            {/* FIX_SSR_LABEL */}
            <Label
              htmlFor={`edit-input-radio-show-${index}`}
              className={`form-label check-label-${rowId}-${colId}-${index}`}
              style={{ display: "inline", marginRight: 2 }}
            >
              {box.label}
            </Label>
            {setLabel({ value: box.label, id: index })}
            {box.hasTip && (
              <div>
                <div
                  className="show-tips"
                  id={`radio-tip-${rowId}-${colId}-${box.id}`}
                >
                  <span>?</span>
                </div>
                <UncontrolledTooltip
                  style={{ backgroundColor: "#6f42c1" }}
                  placement="right"
                  target={`radio-tip-${rowId}-${colId}-${box.id}`}
                >
                  {box.tipText}
                </UncontrolledTooltip>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
